import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';

export default function AdminHirecompo() {
  const [readMessages, setReadMessages] = useState([]);
  const [unreadMessages, setUnreadMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const readResponse = await axios.get('/hiring/getreadmessage');
      const unreadResponse = await axios.get('/hiring/getunreadmessage');
      
      setReadMessages(readResponse.data);
      setUnreadMessages(unreadResponse.data);
      toast.success('Messages fetched successfully');
    } catch (error) {
      console.error('Error fetching messages:', error);
      toast.error('Failed to fetch messages');
    }
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const deleteMessage = async (id) => {
    try {
      await axios.delete(`/hiring/deletemessage/${id}`);
      fetchMessages();
      toast.success('Message deleted successfully');
    } catch (error) {
      console.error('Error deleting message:', error);
      toast.error('Failed to delete message');
    }
  };

  const openMessagePopup = (message) => {
    setSelectedMessage(message);
    setShowPopup(true);
  };

  const closeMessagePopup = async () => {
    if (selectedMessage && !selectedMessage.read) {
      try {
        await axios.put(`/hiring/putread/${selectedMessage._id}`);
        fetchMessages();
        toast.success('Message marked as read');
      } catch (error) {
        console.error('Error marking message as read:', error);
        toast.error('Failed to mark message as read');
      }
    }
    setShowPopup(false);
    setSelectedMessage(null);
  };

  const renderMessages = (messages, title, isUnread) => (
    <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white">
      <div className="flex items-center justify-between px-4 py-3">
        <h2 className="text-xl font-bold">{title}</h2>
        <span className="text-sm text-gray-500">{messages.length} total</span>
      </div>
      <table className="min-w-full text-left text-sm">
        <thead className="bg-gray-50 text-gray-600">
          <tr>
            <th className="px-4 py-3 font-semibold">Name</th>
            <th className="px-4 py-3 font-semibold">Email</th>
            <th className="px-4 py-3 font-semibold">Mobile</th>
            <th className="px-4 py-3 font-semibold">Sent</th>
            <th className="px-4 py-3 font-semibold">Status</th>
            <th className="px-4 py-3 font-semibold">Actions</th>
          </tr>
        </thead>
        <tbody>
          {messages.map((message) => (
            <tr key={message._id} className="border-t border-gray-100">
              <td className="px-4 py-3 font-medium text-gray-900">{message.name_user}</td>
              <td className="px-4 py-3 text-gray-700">{message.email}</td>
              <td className="px-4 py-3 text-gray-700">{message.mobile}</td>
              <td className="px-4 py-3 text-gray-700">{formatDate(message.createdAt)}</td>
              <td className="px-4 py-3">
                <span
                  className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${
                    isUnread
                      ? 'bg-yellow-100 text-yellow-800'
                      : 'bg-green-100 text-green-800'
                  }`}
                >
                  {isUnread ? 'Unread' : 'Read'}
                </span>
              </td>
              <td className="px-4 py-3">
                <button
                  onClick={() => openMessagePopup(message)}
                  className="mr-2 rounded bg-blue-500 px-3 py-1.5 text-white hover:bg-blue-600"
                >
                  View
                </button>
                <button
                  onClick={() => deleteMessage(message._id)}
                  className="rounded bg-red-500 px-3 py-1.5 text-white hover:bg-red-600"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderPopup = () => (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-filter backdrop-blur-sm">
      <div className="w-full max-w-2xl p-5 m-4 bg-white rounded-lg sm:p-8">
        <h2 className="mb-4 text-2xl font-bold">Message from {selectedMessage.name_user}</h2>
        <p><span className="font-semibold">Email:</span> {selectedMessage.email}</p>
        <p><span className="font-semibold">Mobile:</span> {selectedMessage.mobile}</p>
        <p><span className="font-semibold">Message:</span> {selectedMessage.message}</p>
        <p><span className="font-semibold">Sent:</span> {formatDate(selectedMessage.createdAt)}</p>
        <button
          onClick={closeMessagePopup}
          className="px-4 py-2 mt-4 text-white bg-gray-500 rounded hover:bg-gray-600"
        >
          Close
        </button>
      </div>
    </div>
  );

  return (
    <div className="mx-auto max-w-6xl">
      <Toaster position="top-right" />
      <div className="grid gap-6">
        {renderMessages(unreadMessages, "Unread Messages", true)}
        {renderMessages(readMessages, "Read Messages", false)}
      </div>
      {showPopup && renderPopup()}
    </div>
  );
}
